export default __webpack_public_path__ + "static/media/drawforththeheart.05060b24.png";